/*** IMPORTS FROM imports-loader ***/
(function() {

/* eslint-disable no-unused-vars */

class ListMilestone {
  constructor(obj) {
    this.id = obj.id;
    this.title = obj.title;
  }
}

window.ListMilestone = ListMilestone;

}.call(window));


// WEBPACK FOOTER //
// ./boards/models/milestone.js.es6